<template>
  <v-row>
    <v-col
    cols="6"
    xs="5"
    class="text-left"
  >
    <v-btn
      x-small
      elevation="10"
      class="text-xs font-weight-semibold"
      color="primary darken-2"
      :to="{ name: 'savings.insert_client' }"
    >
      <font-awesome-icon
      icon="fa-solid fa-plus"
      class="pe-1"
    />
      Insert Client To zone
    </v-btn>
  </v-col>
  <v-col cols="12">
  <div>
    <h3 class="primary darken-2 pa-2 white--text font-weight-bold">Delete user from zone</h3>
  
  <v-card
    flat
    class="pa-3 mt-1"
  >
      <v-form @submit.prevent="save">
        <!-- Sélecteur de zones -->
        <v-select
        v-model="to_send.zone_name"
        :items="zones"
        item-text="name"
        item-value="spot_name"
        outlined dense
        label="Select a zone"
        ></v-select>

        
        <v-text-field
          v-model="user_name"
          label="Search client by name"
          dense outlined
          @input="onSearchUser"
        />

        <!-- Liste des utilisateurs associés à la zone -->
        <div v-if="users.length > 0" class="user-list">
          <label v-for="user in users" :key="user.id" class="user-item">
            <input type="checkbox" v-model="to_send.list_of_user" :value="user.id" />
            {{ user.name }}
          </label>
        </div>
  
        <v-btn
        type="submit"
        color="primary"
        class="mt-3"
        :disabled="$store.state.isLoading"
      >
        <template v-if="$store.state.isLoading">
          <v-progress-circular
            indeterminate
            size="20"
            color="white"
          ></v-progress-circular>
        </template>
        <template v-else>
          Send
        </template>
      </v-btn>

      </v-form>
    
    </v-card>
    </div>
    </v-col>
    </v-row>
    
  </template>
  
  <script>
  import axios from "axios";
  
  export default {
    data() {
      return {
        users: [], 
        zones: [], 
        user_name:"",
        to_send: {
          list_of_user: [],
          zone_name: "",
        },
      };
    },
    mounted() {
      this.fetchZones();
    },
    watch: {
      "to_send.zone_name"(newZone) {
        if (newZone) {
          this.fetchUsersByZone(newZone);
        }
      },
    },
    methods: {
      onSearchUser() {
        if (this.to_send.zone_name) {
          this.fetchUsersByZone(this.to_send.zone_name);
        }
      },
      resetForm() {
        this.to_send = {
          list_of_user: [],
          zone_name: "",
        };
        this.user_name = "";
        this.users = [];
      },


      async fetchZones() {
        try {
          const response = await axios.post("/api/v1/manager/all_zone/");
          this.zones = response.data;
        } catch (error) {
          if (error.response){
            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
          }else{
            this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
          }
        }
      },
      async fetchUsersByZone(zone) {
        try {
          const response = await axios.post("/api/v1/manager/get_user_by_zone/", { zone_name: zone,user_name:this.user_name});
          this.users = response.data;
          this.to_send.list_of_user = [];
        } catch (error) {
          if (error.response){
            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
          }else{
            this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
          }
        }
      },
      async save() {
        this.$store.commit("setIsLoading", true);
        try {
          if (this.to_send.list_of_user.length === 0) {
            alert("Please select at least one user.");
            return;
          }
  
          const response = await axios.post("/api/v1/manager/delete_user_zone/", this.to_send);
          this.$store.commit("setSnackBarMessage", response.data.success);
          this.$store.commit("setSnackBarColor", "green");
          this.$store.commit("activateSnackBar", true);
          this.resetForm();
        } catch (error) {
            let errorMessage = "An error has occurred.";
            if (error.response && error.response.data.error) {
              errorMessage = error.response.data.error;
            }
            this.$store.commit("setSnackBarMessage", errorMessage);
            this.$store.commit("setSnackBarColor", "red");
            this.$store.commit("activateSnackBar", true);
          }

       this.$store.commit("setIsLoading", false);
      },
    },
  };
  </script>
  
  <style scoped>
  .user-list-container {
    width: 350px;
    border: 1px solid #ddd;
    padding: 15px;
    border-radius: 5px;
    background: #f9f9f9;
  }
  
  /* Liste des utilisateurs scrollable */
  .user-list {
    max-height: 150px; /* 5 utilisateurs visibles (~30px chacun) */
    overflow-y: auto;
    border: 1px solid #ccc;
    padding: 5px;
    background: white;
  }
  
  .user-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 5px;
  }
  </style>
  